import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useMobileBreakpoint from '../../../../hooks/useMobileBreakpoint';
import './styles.less';

const TriptychLayoutFooter = ({ children }) => {
  const isMobile = useMobileBreakpoint();

  const footerClassName = classNames('triptych-footer', {
    'triptych-footer--small-padding': isMobile,
    'triptych-footer--mobile': isMobile,
  });

  return (
    <div className={footerClassName}>
      <div className="triptych-footer__content">{children}</div>
    </div>
  );
};

TriptychLayoutFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TriptychLayoutFooter;
